export function formatFlowAlarm(flags?: string[], raw?: number): string {
    if (flags && flags.length > 0) {
        return flags.map(f => {
            if (f === 'slow') return 'Slow Leak';
            if (f === 'overflow') return 'Overflow';
            if (f === 'burst') return 'Burst';
            return f;
        }).join(' + ');
    }
    if (raw !== undefined && raw > 0) {
        return `Flow Leak (${raw})`;
    }
    return '';
}

export function isContactSensor(item: { device_eui?: string; device_name?: string; anomaly_type?: string; type?: string }): boolean {
    const eui = (item.device_eui || '').toLowerCase();
    const name = (item.device_name || '').toLowerCase();
    const anom = (item.anomaly_type || item.type || '').toLowerCase();
    return (
        eui.startsWith('726c6966') || // rlif prefix (rope/leak/flood)
        name.includes('flood') ||
        name.includes('rope') ||
        name.includes('puck') ||
        name.includes('contact') ||
        name.includes('moisture') ||
        anom.includes('flood') ||
        anom.includes('rope') ||
        anom.includes('contact')
    );
}

export function isContactAlert(item: any): boolean {
    if (isContactSensor(item)) return true;
    if (item.malfunction_alarms && Array.isArray(item.malfunction_alarms)) {
        if (item.malfunction_alarms.some((m: string) => /flood|rope|wet|contact/i.test(m))) {
            return true;
        }
    }
    if (item.ml_anomalies && Array.isArray(item.ml_anomalies)) {
        if (item.ml_anomalies.some((a: any) => /flood|rope|contact/i.test(a.type || ''))) {
            return true;
        }
    }
    return false;
}

export function isContinuousFlowAlert(item: any): boolean {
    return Boolean(item.flow_alarm && item.flow_alarm > 0);
}
export const isFlowLeakAlert = isContinuousFlowAlert;

export function isMalfunctionAlert(item: any): boolean {
    return Boolean(item.malfunction_alarms && item.malfunction_alarms.length > 0);
}
export const isFaultAlert = isMalfunctionAlert;

export function isMlAnomalyAlert(item: any): boolean {
    if (item.log_type === 'anomaly') return true;
    return Boolean(item.ml_anomalies && item.ml_anomalies.length > 0);
}

export function groupAnomalies(anomalies: any[] = []): { type: string; items: any[] }[] {
    const groups = new Map<string, any[]>();
    for (const anomaly of anomalies) {
        const type = String(anomaly.type || 'Unknown').toUpperCase();
        if (!groups.has(type)) groups.set(type, []);
        groups.get(type)!.push(anomaly);
    }
    return Array.from(groups, ([type, items]) => ({ type, items }));
}

/**
 * Maps protocol malfunction alarm codes to human-readable labels.
 *
 * Supported status alert codes:
 * - bl: Battery voltage low
 * - fm / flow_fault: Flow sensor fault
 * - tm / temp_fault: Temperature sensor fault
 * - vm / valve_fault: Valve fault
 * - cm / comm_fault: Communication fault
 */
export function malfunctionLabel(code: string): string {
    switch (code) {
        case 'bl': return 'Battery voltage low';
        case 'fm':
        case 'flow_fault': return 'Flow sensor fault';
        case 'tm':
        case 'temp_fault': return 'Temperature sensor fault';
        case 'vm':
        case 'valve_fault': return 'Valve fault';
        case 'cm':
        case 'comm_fault': return 'Communication fault';
        default: return code;
    }
}


